import { CheckNotes, InspectionCase } from '../../inspection-cases';

export class FireExtinguishingPumpsDto extends InspectionCase {
  shutdownPumpType?: InspectionCase;
  nominalPumpCapacityPressure?: InspectionCase;
  pumpDesignAccordingSpec?: InspectionCase;
  emergencyGeneratorSwitching?: InspectionCase;
  jockeyPumpSpeedPressure?: InspectionCase;
}

export class FireExtinguishingPumps extends FireExtinguishingPumpsDto {
  constructor(
    data: FireExtinguishingPumpsDto = {
      title: 'משאבה/ות כיבוי אש בהתאם לדרישות NFPA-20'
    }
  ) {
    super(data);
    this.shutdownPumpType = new InspectionCase({
      ...data.shutdownPumpType,
      title: 'פרט סוג משאבה/ות  בכיבוי שתוכננו'
    });
    this.nominalPumpCapacityPressure = new InspectionCase({
      ...data.nominalPumpCapacityPressure,
      title: 'ציין את הספיקות והלחצים הנומינליים של משאבה/ות'
    });
    this.pumpDesignAccordingSpec = new InspectionCase({
      ...data.pumpDesignAccordingSpec,
      title:
        'תכנון המשאבות בהתאם לדרישות התקן (קטרים, מגופים, אביזרים, מד ספיקה , שעוני לחץ וקווי פיקוד)'
    });
    this.emergencyGeneratorSwitching = new InspectionCase({
      ...data.emergencyGeneratorSwitching,
      title: 'מיתוג לגנרטור חירום (במשאבה חשמלית)'
    });
    this.jockeyPumpSpeedPressure = new InspectionCase({
      ...data.jockeyPumpSpeedPressure,
      title: `ציין את הספיקות והלחצים של משאבת הג'וקי`
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.shutdownPumpType.isApplicable ||
        this.shutdownPumpType.isPassed) &&
        (!this.nominalPumpCapacityPressure.isApplicable ||
          this.nominalPumpCapacityPressure.isPassed) &&
        (!this.pumpDesignAccordingSpec.isApplicable ||
          this.pumpDesignAccordingSpec.isPassed) &&
        (!this.emergencyGeneratorSwitching.isApplicable ||
          this.emergencyGeneratorSwitching.isPassed) &&
        (!this.jockeyPumpSpeedPressure.isApplicable ||
          this.jockeyPumpSpeedPressure.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.shutdownPumpType.getNotes(),
      ...this.nominalPumpCapacityPressure.getNotes(),
      ...this.pumpDesignAccordingSpec.getNotes(),
      ...this.emergencyGeneratorSwitching.getNotes(),
      ...this.jockeyPumpSpeedPressure.getNotes()
    ];
  }
}
